import { ButtonBase, Dialog, Drawer, Paper, styled as muiStyled } from '@mui/material'

export const TimerCircle = muiStyled('div')(
  ({ theme, bgImgUrl }) => `
    border-radius: 10px;
    position: relative;
    background: url('${bgImgUrl}');
    // aspect-ratio: 3/2;
    width: 100%;
    max-width: 340px;
    max-height: 227px;
    height: 100%;
    margin: 0 auto;
    background: rgba(0, 0, 0, 0.57);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(13.1px);
    -webkit-backdrop-filter: blur(13.1px);
    border: 1px solid rgba(0, 0, 0, 0.42);
    display:flex;
    flex-direction: column;
    justify-content: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
    align-items:center;
    font-size: 68px;
    padding: 0px 30px;
    .small-text{
      font-size: 16px;
    }
    gap: 5px;
    @media (min-width: 768px) {
      .small-text{
        font-size: 20px;
      }
      font-size: 80px;
      gap: 25px;
      max-width: 480px;
      max-height: 320px;
    }
`,
)

export const PracticeTimerContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    padding: 20px;
    position: relative;
    width: 100%;
`,
)

export const PausePlayIconButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  background-color: #000;
  border-radius: 50%;
  padding: 15px;
  color: #fff;
  box-shadow: 0px 0px 10px -1px #fff;
  transition: all 0.3s;
  font-size: 28px;
  &:hover{
    background-color: #222;
  }

`,
)

export const CountdownContainer = muiStyled('div')(
  ({ theme }) => `
  position: absolute;
  top:0;
  left: 0;
  background: #ffffffc9;
    backdrop-filter: blur(8.1px);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  text-align: center;
  padding: 30px 22px 80px 22px;

  .countdown-timer{
    font-size: 90px;
    font-weight: 200;
    line-height: 90px;
  }
  .small-heading{
    font-size: 24px;
    color: #5547d0bf;
    font-weight: 400;
  }
  @media(min-width: 768px){
    .small-heading{
      font-size: 20px;
    } 
  }
`,
)

export const FinishPracticeButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  border-radius: 200px;
  padding: 10px 15px;
  border: 1px solid #ffffffd1;
  background: #000;
  color: #fff;
  width: 160px;
  transition: all 400ms ${theme.transitions.easing.quickInOut};
  &:hover{
    background: #222;
  }
  :disabled {
    color: #717171;
    border:1px solid #00000059;
  }
`,
)

export const BeginPracticeButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  font-size: 18px;
  border-radius: 200px;
  padding: 10px 20px;
  border: 1px solid #000;
  width: 160px;
  transition: all 400ms ${theme.transitions.easing.quickInOut};
  &:hover{
    color: white;
    background-color: #7450aa;
    border:1px solid #9c9c9c00;
    // box-shadow: 0px 2px 5px -2px #000;
  
  }
`,
)

export const PracticeTimerButtonsContainer = muiStyled('div')(
  ({ theme }) => `
display: flex;
flex-direction: column;
align-items: center;
justify-content:center;
gap: 40px;
margin-top: 10px;
@media (min-width: 768px) {
  gap: 40px;
}
`,
)

export const TimerSubTime = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  color: #00000070;
  `,
)

export const LockedPlannedActivityOverlay = muiStyled('div')(
  ({ theme }) => `
  background: #000000b3;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
`,
)

export const TimerClockDataContainer = muiStyled('div')(
  ({ theme }) => `
  color: white;
width: 100%;
display:flex;
flex-direction: column;
justify-content: center;
background-size: cover;
font-size: inherits;
z-index: 0;
gap: 4px;
@media (min-width: 768px) {
  gap: 25px;
}
`,
)

export const TimerDigitsContainer = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  font-family: "Roboto Mono", monospace;
`,
)

export const NegativeTimerContainer = muiStyled('div')(
  ({ theme }) => `
display: grid;
grid-template-columns: 2fr 1fr 2fr;
gap: 5px;
justify-items:center;
`,
)
export const PracticeTimerFinishDrawer = muiStyled(Drawer)(
  ({ theme }) => `
  .MuiBackdrop-root{
    background: rgb(82 82 82 / 81%);
    backdrop-filter: blur(13.1px);
  }
  .MuiPaper-root {
    background:rgba(0, 0, 0, 0.57);
    border-top: 1px solid #7257ffbf;
  }
`,
)

export const PracticeTimerCongratulatoryDialogPaper = muiStyled(Paper)(
  ({ theme, longDialog }) => `
  border-radius: 7px;
  max-width: 576px !important;
    width: 100% !important;
    height: 100% !important;
    max-height: ${longDialog ? '650px' : '450px'} !important;
    margin: 0 !important;
    background-color: #000000a6;
    color: #fff;
    transition: 400ms all ${theme.transitions.easing.quickInOut};
`,
)

export const PracticeTimerCongratulatoryDialogComponent = muiStyled(Dialog)(
  ({ theme }) => `
  backdrop-filter: blur(8.1px);
  background: rgb(0 0 0 / 57%);
  .MuiDialog-container{
    align-items: flex-end;
    @media (min-width: 576px){
      align-items: center;
    }
  }
  .MuiBackdrop-root{
  background:#3c3c3c80;
}
`,
)

export const BackButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  border-radius: 30px;
  padding: 10px 18px;
  gap: 14px;
  transition: all 300ms;
  &:hover {
    background: #0000001f;
  }
`,
)

export const TimerContainerForTransition = muiStyled('div')(
  ({ theme, transitionIn }) => `
  opacity: ${transitionIn ? 1 : 0};
  transition: opacity 400ms ${theme.transitions.easing.quickInOut};
`,
)

export const MainTimerContainer = muiStyled('div')(
  ({ theme }) => `
height: 100%;
width: 100%;
display: flex;
flex-direction: column;
justify-content: space-between;
align-items: center;
`,
)

export const IntervalsLeft = muiStyled('div')(
  ({ theme }) => `
  width: 100%;
  display: flex;
  justify-content: center;
  align-items:center;
  gap: 5px;
  font-size: 16px;
  .no-margin-span {
    margin: 0;
  }
`,
)
